export const getUrlParamValueByKey = (key: string, searchParams?: string) => {
  if (key) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(searchParams || url.search);
    const value = params.get(key);
    return value !== undefined ? value : null;
  } return null;
};

export const URL_KEYS = {
  FROM_TRACKER: 'fromTracker',
};
